module.exports = __webpack_public_path__ + "img/Human_symbol_7.f4c76cef.png";